class ManageSimulationDataController {
    constructor($window, $browser, $uibModal, ModalService, toastr, UserDetails, ngProgressFactory, AppServiceApi, SimulationDataServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.rufUrl = 'RUF/simulator/simulation-data?embed=true';
            this.data = {
                simulationDataModels: [],
                simulationDataTypes: []
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            let modelColumnDefs = [
                { headerName: 'Type', field: 'TypeName', width: 80, minWidth: 100 },
                { headerName: 'Version', field: 'TypeVersion', width: 80, minWidth: 100 },
                { headerName: 'Name', field: 'Name', cellRenderer: this.popoverRenderer, minWidth: 100, sort: 'asc' },
                { headerName: 'Sequence', field: 'Sequence', width: 100, minWidth: 100 },
                { headerName: 'Actions', width: 100, cellRenderer: this.modelsActionsCellRenderer, sortable: false, suppressMenu: true }
            ];
            this.modelsGridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: true
                },
                columnDefs: modelColumnDefs,
                rowSelection: 'single',
                rowHeight: 28,
                angularCompileRows: true,
                suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
                sortingOrder: ['asc', 'desc', null],
                onGridSizeChanged: () => {
                    this.modelsGridOptions.api.setRowData(this.data.simulationDataModels);
                    this.modelsGridOptions.api.sizeColumnsToFit();
                }
            };
            let typeColumnDefs = [
                { headerName: 'Type Name', field: 'TypeName', width: 120, minWidth: 100 },
                { headerName: 'Display Name', field: 'DisplayName', minWidth: 100, sort: 'asc' },
                { headerName: 'Formly Filename', field: 'FormlyFilename', width: 100, minWidth: 100 },
                { headerName: 'Icon', field: 'Icon', width: 100, minWidth: 100 },
                { headerName: 'Version', field: 'Version', width: 100, minWidth: 100 },
                { headerName: 'Actions', width: 100, cellRenderer: this.typesActionsCellRenderer, sortable: false, suppressMenu: true }
            ];
            this.typesGridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: true
                },
                columnDefs: typeColumnDefs,
                rowHeight: 28,
                rowSelection: 'single',
                angularCompileRows: true,
                suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
                sortingOrder: ['asc', 'desc', null],
                onGridSizeChanged: () => {
                    this.typesGridOptions.api.setRowData(this.data.simulationDataTypes);
                    this.typesGridOptions.api.sizeColumnsToFit();
                }
            };
            this.AppServiceApi.settings().then((response) => {
                this.responseAppSettings = response.data;
                this.enableRUF = this.responseAppSettings.EnableRUF && this.responseAppSettings.EnableRUFComponents.some(c => c.toLowerCase() === 'managesimulationdata');
                if (!this.enableRUF)
                    this.refreshAllData();
                this.UserDetails.get().then((data) => {
                    this.traceProgress.complete();
                    this.userDetails = data;
                }, () => {
                    this.traceProgress.complete();
                    this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                    this.window.location.href =
                        this.browser.baseHref() + 'account/login';
                    return;
                });
            });
            this.startLoading();
        };
        this.popoverRenderer = (row) => {
            let text = [
                '<span',
                'uib-popover="', row.value.replace(/"/g, '&quot;'), '"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="bottom"',
                'popover-append-to-body="true">',
                row.value,
                '</span>'
            ].join(' ');
            return text;
        };
        this.modelsActionsCellRenderer = (row) => {
            let editItem = this.createAction('vm.editItem(\'model\', data)', 'Edit ' + row.data.Name, 'glyphicon glyphicon-pencil', '');
            let viewItem = this.createAction('vm.viewItem(data)', 'View Simulators Using ' + row.data.Name, 'glyphicon glyphicon-search', '');
            let deleteItem = this.createAction('vm.deleteItem(\'model\', data)', 'Delete ' + row.data.Name, 'glyphicon glyphicon-trash', '');
            return editItem + viewItem + deleteItem;
        };
        this.typesActionsCellRenderer = (row) => {
            let editItem = this.createAction('vm.editItem(\'type\', data)', 'Edit ' + row.data.DisplayName, 'glyphicon glyphicon-pencil', '');
            let deleteItem = this.createAction('vm.deleteItem(\'type\', data)', 'Delete ' + row.data.DisplayName, 'glyphicon glyphicon-trash', '');
            return editItem + deleteItem;
        };
        this.createAction = (method, popoverText, icon, spinner) => {
            let action = [
                '<button class="space-left btn btn-xs btn-info"',
                'ng-click="', method, '"',
                'uib-popover="', popoverText, '"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '<i class="', icon, 'space-right">',
                '</i>',
                spinner,
                '</button>'
            ].join(' ');
            return action;
        };
        this.addItem = (type) => {
            this.editItem(type, null);
        };
        this.editItem = (type, value) => {
            switch (type) {
                case 'model':
                    let editModelModal = this.uibModal.open({
                        animation: true,
                        component: 'addEditSimulationDataModelModal',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            simulationDataModel: () => {
                                return value;
                            },
                            simulationDataTypes: () => {
                                return this.data.simulationDataTypes;
                            }
                        }
                    });
                    editModelModal.result.then((value) => {
                        this.refreshAllData();
                        this.toastr.info([
                            'Simulation Data ',
                            value
                        ].join(''));
                    });
                    break;
                case 'type':
                    let editTypeModal = this.uibModal.open({
                        animation: true,
                        component: 'addEditSimulationDataTypeModal',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            simulationDataType: () => {
                                return value;
                            }
                        }
                    });
                    editTypeModal.result.then((value) => {
                        this.refreshAllData();
                        this.toastr.info([
                            'Simulation Type ',
                            value
                        ].join(''));
                    });
                    break;
            }
        };
        this.deleteItem = (type, value) => {
            switch (type) {
                case 'model':
                    this.startLoading();
                    this.SimulationDataServiceApi.getSimulatorsForModel(value.Id).then((response) => {
                        this.endLoading();
                        let sims = response.data;
                        let modalOptions = {
                            backdrop: 'static',
                            actionButtonText: 'Delete',
                            closeButtonText: 'Cancel',
                            headerText: 'Delete Simulation Data Model',
                            bodyText: 'Are you sure you want to delete ' + value.Name + '?'
                        };
                        if (sims.length > 0) {
                            modalOptions.bodyText = modalOptions.bodyText + ' It\'s currently being used by ' + sims.length + ' simulator(s).';
                        }
                        this.ModalService.showModal({}, modalOptions).then(() => {
                            this.startLoading();
                            this.SimulationDataServiceApi.deleteModel(value.Id).then((response) => {
                                this.endLoading();
                                if (response.data) {
                                    this.toastr.info(value.Name + ' deleted');
                                    this.refreshAllData();
                                }
                                else {
                                    this.toastr.info('Error deleting ' + value.Name);
                                }
                            });
                        });
                    });
                    break;
                case 'type':
                    this.startLoading();
                    this.SimulationDataServiceApi.getModelsForType(value.Id).then((response) => {
                        this.endLoading();
                        let models = response.data;
                        let modalOptions = {
                            backdrop: 'static',
                            actionButtonText: 'Delete',
                            closeButtonText: 'Cancel',
                            headerText: 'Delete Simulation Data Type',
                            bodyText: 'Are you sure you want to delete ' + value.TypeName + '?'
                        };
                        if (models.length > 0) {
                            modalOptions.bodyText = modalOptions.bodyText + ' It\'s currently being used by ' + models.length + ' models(s).';
                        }
                        this.ModalService.showModal({}, modalOptions).then(() => {
                            this.startLoading();
                            this.SimulationDataServiceApi.deleteType(value.Id).then((response) => {
                                this.endLoading();
                                if (response.data) {
                                    this.toastr.info(value.TypeName + ' deleted');
                                    this.refreshAllData();
                                }
                                else {
                                    this.toastr.info('Error deleting ' + value.TypeName);
                                }
                            });
                        });
                    });
                    break;
            }
        };
        this.viewItem = (model) => {
            this.startLoading();
            this.SimulationDataServiceApi.getSimulatorsForModel(model.Id).then((response) => {
                this.endLoading();
                let sims = response.data;
                let viewModal = this.uibModal.open({
                    animation: true,
                    component: 'viewSmallSimulatorListModal',
                    size: 'md',
                    backdrop: 'static',
                    resolve: {
                        title: () => {
                            return 'Simulators using ' + model.Name;
                        },
                        simulators: () => {
                            return sims;
                        },
                        actionsCellRenderer: () => {
                            return (params) => {
                                const goToManageSimulator = [
                                    '<span class="btn btn-info btn-xs "',
                                    'ng-click="vm.cancel(); vm.$location.path(\'/ManageSimulators/' + params.data.Id + '\');"',
                                    'uib-popover="Manage simulation data for ' + params.data.SimName + '"',
                                    'popover-animation',
                                    'popover-trigger="\'mouseenter\'"',
                                    'popover-placement="left"',
                                    'popover-append-to-body="true">',
                                    '<i class="glyphicon glyphicon-book"></i>',
                                    '</span>'
                                ].join(' ');
                                return goToManageSimulator;
                            };
                        }
                    }
                });
                viewModal.result.then(() => {
                });
            });
        };
        this.refreshAllData = () => {
            this.startLoading();
            this.SimulationDataServiceApi.getShortModels().then((response) => {
                this.data.simulationDataModels = response.data;
                this.modelsGridOptions.api.setRowData(this.data.simulationDataModels);
                if (this.modelsGridOptions.columnApi.getAllDisplayedColumns().length > 0) {
                    this.modelsGridOptions.api.sizeColumnsToFit();
                }
                this.SimulationDataServiceApi.getTypes().then((response) => {
                    this.data.simulationDataTypes = response.data;
                    this.typesGridOptions.api.setRowData(this.data.simulationDataTypes);
                    if (this.typesGridOptions.columnApi.getAllDisplayedColumns().length > 0) {
                        this.typesGridOptions.api.sizeColumnsToFit();
                    }
                    this.endLoading();
                });
            });
        };
        this.startLoading = () => {
            this.traceProgress.start();
            if (!_.isNil(this.modelsGridOptions.api)) {
                this.modelsGridOptions.api.showLoadingOverlay();
            }
            if (!_.isNil(this.typesGridOptions.api)) {
                this.typesGridOptions.api.showLoadingOverlay();
            }
        };
        this.endLoading = () => {
            this.traceProgress.complete();
            if (!_.isNil(this.modelsGridOptions.api)) {
                this.modelsGridOptions.api.hideOverlay();
            }
            if (!_.isNil(this.typesGridOptions.api)) {
                this.typesGridOptions.api.hideOverlay();
            }
        };
        this.window = $window;
        this.browser = $browser;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.ngProgressFactory = ngProgressFactory;
        this.AppServiceApi = AppServiceApi;
        this.UserDetails = UserDetails;
        this.SimulationDataServiceApi = SimulationDataServiceApi;
    }
}
angular.module('app').component('manageSimulationData', {
    bindings: {},
    templateUrl: 'Scripts/App/partials/SimulationData/admin/manage-simulation-data.tpl.html',
    controllerAs: 'vm',
    controller: ManageSimulationDataController
});
